export default "__VITE_ASSET__CRv9T5DC__"